angular.module('unergie.main')
.filter('accountStatus', (ReferencesService) => {
    let data = null
    let serviceInvoked = false

    const realFilter = function (value) {
        if ((value !== undefined) && data) {
            return data[parseInt(value, 10)][0].label_fr
        }
        return value
    }

    const filterStub = function (value) {
        if (data === null) {
            if (!serviceInvoked) {
                serviceInvoked = true
                ReferencesService.getRef('accountStatus').then((accountStatusMapping) => (data = accountStatusMapping))
            }
            return 'loading ...'
        }
        return realFilter(value)
    }

    filterStub.$stateful = true
    return filterStub
})
